import { render, staticRenderFns } from "./ImportDimensionsDialogWidget.vue?vue&type=template&id=257e9589&"
import script from "./ImportDimensionsDialogWidget.vue?vue&type=script&lang=js&"
export * from "./ImportDimensionsDialogWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports